// extracted by mini-css-extract-plugin
module.exports = {"globalizationChooser":"GlobalizationChooser_globalizationChooser__12Aso"};